import { JSX } from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";

import Icon from "@/components/common/Icon/Icon.tsx";

const Information = ({ title, markdown }: { title: string; markdown: string }): JSX.Element => {
  return (
    <main className={"mx-auto flex max-w-[70.625rem] flex-col items-center gap-20 py-10 text-center font-Inter"}>
      <Link to={"/"} title={"На главную"}>
        <Icon name={"splay"} className={"h-[3.125rem] w-[6rem]"} />
      </Link>
      <div className={"space-y-10 max-md:space-y-5"}>
        <h1 className={"text-start text-[3.125rem] font-semibold max-md:text-[2rem] max-sm:text-xl"}>{title}</h1>
        <article
          className={
            "prose prose-white max-w-none text-start max-md:text-xs max-sm:text-[0.8rem] max-sm:[&>h1]:text-xl  "
          }
        >
          <ReactMarkdown>{markdown}</ReactMarkdown>
        </article>
      </div>
    </main>
  );
};

export default Information;
